import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const RefreshButton = (props: IAppButtonProps) => (
    <AppButton
        variant="text"
        color="inherit"
        startIcon={<CachedOutlinedIcon />}
        {...props}
    >
        {props.children}
    </AppButton>
);